import { Box, IconButton, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { Task } from "../../../api/Tasks";
import { panelFontSize } from "../panel/PanelSection";
import { TaskPicker } from "../TaskPicker";

// BulkTaskLinks collects the tasks the selected tasks are linked to, one or more
export function BulkTaskLinks(props: {
    placeholder: string;
    value: Task[];
    onChange: (value: Task[]) => void;

    // exclude leaves the selected tasks out of the search
    exclude: number[];
}) {
    return (
        <Box sx={{ minWidth: 0 }}>
            {props.value.map(task => (
                <Box key={task.id} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography noWrap sx={{ flex: 1, minWidth: 0, fontSize: panelFontSize }}>
                        #{task.id} {task.title}
                    </Typography>
                    <IconButton size="small" aria-label="Remove"
                                onClick={() => props.onChange(props.value.filter(row => row.id !== task.id))}>
                        <Close sx={{ fontSize: 14 }} />
                    </IconButton>
                </Box>
            ))}

            <TaskPicker
                placeholder={props.placeholder}
                exclude={props.exclude.concat(props.value.map(task => task.id))}
                onPick={task => props.onChange(props.value.concat(task))}
            />
        </Box>
    );
}
